import { Component, Vue } from "vue-property-decorator";
import Axios from "../../plugins/http";

@Component
export default class Index extends Vue {
    search:any = {
        searchBind:'',
        searchMatch:'',
    };
    pageNo:number = 1;
    total:number = 0;
    pageSize:number = 20;
    tableData:any = [{}];
    isAdd:boolean = false;
    addForm:any = {
        extraCode:'',
        skuCodes:''
    };

    created() {
        this.getList();
    }
    onSearch(){
        this.pageNo = 1;
        this.getList();
    }
    onRest(){
        this.pageNo = 1;
        this.search.searchBind = '';
        this.search.searchMatch = '';
        this.getList();
    }
    getList(){
        let data = {
            pageNo:this.pageNo,
            size:this.pageSize,
            searchBind:this.search.searchBind,
            searchMatch:this.search.searchMatch
        }
        Axios.postByJson(`/api/skuCodeExtra/page`,data).then((res:any)=>{
            if(res.data.status == 200){
                this.pageNo = Number(res.data.data.current);
                this.total = Number(res.data.data.total);
                if(res.data.data.records){
                    res.data.data.records.map((item:any)=>{
                        item.isEdit = false;
                    })
                }
                this.tableData = res.data.data.records || []
            }else{
                this.pageNo = 1;
                this.total = 0;
                this.tableData = [];
            }
        })
    }
    changePage(e){
        this.pageNo = e;
        this.getList();
    }
    onAdd(){
        this.isAdd = true;
    }
    onSubmit(){
        if(this.addForm.skuCodes === ''){
            this.$message.error('匹配货物编号不可为空');
            return;
        }
        let skuCodes = this.addForm.skuCodes.split(',');
        let checked = skuCodes.filter((item:any)=>{
            return /^[1-9]\d*$/.test(item) || item.split('_')[0] == 'x'
        })
        if(checked.length != skuCodes.length){
            this.$message.error('匹配货物编号只能输纯数字和x开头的三段码');
            return;
        }
        if(this.addForm.extraCode === ''){
            this.$message.error('绑定货物编号不可为空');
            return;
        }
        let data = {
            extraCode:this.addForm.extraCode,
            skuCodes:this.addForm.skuCodes,
        }
        Axios.postByJson(`/api/skuCodeExtra/save`,data).then((res:any)=>{
            if(res.data.status == 200){
                this.$message({
                    message: '保存成功',
                    type: 'success'
                })
                this.getList();
                this.handleClose();
            }else{
                this.$message.error(res.data.msg);
            }
        })
    }
    handleClose(){
        this.isAdd = false;
        this.addForm = {
            skuCodes:'',
            extraCode:''
        }
    }
    onEdit(props:any){
        props.isEdit = true;
    }
    onSave(props:any){
        if(props.skuCodes == ''){
            this.$message.error('匹配货物编号不可为空');
            return;
        }
        if(props.extraCode == ''){
            this.$message.error('绑定货物编号不可为空');
            return;
        }
        let data = {
            extraCode:props.extraCode,
            skuCodes:props.skuCodes,
            id:props.id,
        }
        
        Axios.postByJson(`/api/skuCodeExtra/save`,data).then((res:any)=>{
            if(res.data.status == 200){
                this.$message({
                    message: '保存成功',
                    type: 'success'
                })
                this.getList();
            }else{
                this.$message.error(res.data.msg);
            }
        })
    }
    onDel(props:any){
        this.$confirm('确认删除吗? 删除后匹配规则将失效', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            Axios.postByJson(`/api/skuCodeExtra/delete`,{id:props.id}).then((res:any)=>{
                if(res.data.status == 200){
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                    this.getList();
                }else{
                    this.$message.error(res.data.msg);
                }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
    }
}